import React from 'react';
import { Grid, Box, Typography, Paper } from '@mui/material';
import { MaintenanceAndFuelStats as MaintenanceAndFuelStatsType } from '../../../services/dashboardService';
import { useTranslation } from 'react-i18next';
import BuildIcon from '@mui/icons-material/Build';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import EuroIcon from '@mui/icons-material/Euro';

interface MaintenanceAndFuelStatsProps {
  data: MaintenanceAndFuelStatsType;
}

/**
 * Composant pour afficher les statistiques d'entretien et de carburant
 */
const MaintenanceAndFuelStats: React.FC<MaintenanceAndFuelStatsProps> = ({ data }) => {
  const { t } = useTranslation();

  const stats = [
    {
      label: t('dashboard:maintenanceAndFuel.maintenanceFiles'),
      value: data.maintenanceFiles,
      icon: <BuildIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:maintenanceAndFuel.plannedMaintenance'),
      value: data.plannedMaintenance,
      icon: <EventAvailableIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:maintenanceAndFuel.fuelTickets'),
      value: data.fuelTickets,
      icon: <LocalGasStationIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:maintenanceAndFuel.totalExpenses'),
      value: `${data.totalExpenses.toLocaleString()}€`,
      icon: <EuroIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat, index) => (
        <Grid item xs={6} key={index}>
          <Paper
            sx={{
              p: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
            }}
            elevation={1}
          >
            <Box sx={{ mb: 1 }}>{stat.icon}</Box>
            <Typography variant="h6" component="div" align="center">
              {stat.value}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {stat.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default MaintenanceAndFuelStats;